import { Fingerprint, Upload } from 'lucide-react'
import type { AttendanceSource } from '../types/hrmsAttendanceRecords.types'

interface AttendanceSourceBadgeProps {
  source: AttendanceSource
}

export function AttendanceSourceBadge({ source }: AttendanceSourceBadgeProps) {
  if (!source || source === '—') {
    return <span className="text-slate-400 font-medium">—</span>
  }

  const normalized = String(source).trim().toUpperCase()

  if (normalized === 'BIOMETRIC') {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-teal-50 px-2.5 py-1 text-xs font-semibold text-teal-800 border border-teal-200 whitespace-nowrap">
        <Fingerprint className="h-3.5 w-3.5 text-teal-600 shrink-0" />
        Biometric
      </span>
    )
  }

  if (normalized === 'MANUAL_IMPORT' || normalized === 'MANUAL IMPORT' || normalized === 'IMPORT') {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-700 border border-slate-200 whitespace-nowrap">
        <Upload className="h-3.5 w-3.5 text-slate-500 shrink-0" />
        {normalized === 'IMPORT' ? 'Import' : 'Manual Import'}
      </span>
    )
  }

  if (normalized === 'MANUAL') {
    return (
      <span className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-700 border border-slate-200 whitespace-nowrap">
        <Upload className="h-3.5 w-3.5 text-slate-500 shrink-0" />
        Manual
      </span>
    )
  }

  // Format any other custom source nicely (e.g. "REGULARIZED" -> "Regularized")
  const label =
    String(source).charAt(0).toUpperCase() +
    String(source).slice(1).toLowerCase().replace(/_/g, ' ')

  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-700 border border-slate-200 whitespace-nowrap">
      {label}
    </span>
  )
}
